const state = {
	isLogin: false,
	commentId: "",
	newsDynamicArr: [],//新闻管理
	combatArr: [], //师资介绍
	enrollmentArr: [],//招生简章
	boSumPublishArr: [],//博商出版
	caseArr: [],//案例
	reportArr: [],//行业报告
	courseArr: [],//课程资讯
	currentLang: 'zh-cn',
};
export default state;



// WEBPACK FOOTER //
// ./src/store/store.js